import styled from "styled-components";

const Form = styled.form`
  max-width: 380px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

export default Form;
